import { render, staticRenderFns } from "./PageFooterNew.vue?vue&type=template&id=14829e86&scoped=true&"
import script from "./PageFooterNew.vue?vue&type=script&lang=js&"
export * from "./PageFooterNew.vue?vue&type=script&lang=js&"
import style0 from "./PageFooterNew.vue?vue&type=style&index=0&id=14829e86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14829e86",
  null
  
)

export default component.exports